
export const REDUCER = {
  PETTY_CASHIER: {
    PAYMENT: "PettyCashierPayment",
    RECEIVE: "PettyCashierReceive",
    PETTY_CASH: "PettyCashierPettyCash",
  },
  MANAGER: {
    PAYMENT: "ManagerPayment",
    RECEIVE: "ManagerReceive",
    PETTY_CASH: "ManagerPettyCash",
  },
  COMMON:{
    PREMIUM_PLAN: "Premium",
  }
};
